module.exports = __webpack_public_path__ + "static/media/valentines_day_heart.6f06e9b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/valentines_day/valentines_day_heart.png
// module id = 310
// module chunks = 0